import React, { useState } from 'react';

const WeatherDataPagination = ({ data = [], columns = [], rowsPerPage = 10,title,type=null }) => {
  const [currentPage, setCurrentPage] = useState(1);

  if (!Array.isArray(data) || data.length === 0 || columns.length === 0) return <p>No data available</p>;

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const startIdx = (currentPage - 1) * rowsPerPage;
  const currentRows = data.slice(startIdx, startIdx + rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className={type==='wind' ? "weather_info fWidth" : "weather_info hail_data"}>
        <h5>{title}</h5>
      <table className={"table"}>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td key={colIndex}>
                  {
                    col?.value ? col.value :
                  typeof col.render === 'function' ? col.render(row) : row[col.accessor]
                  }
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      {totalPages > 1 && (
          <ul className="pagination justify-content-center">
            {Array.from({ length: totalPages }, (_, i) => (
              <li
                key={i}
                className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}
              >
                <a role="button" className="page-link" onClick={() => handlePageChange(i + 1)}>
                  {i + 1}
                </a>
              </li>
            ))}
          </ul>
      )}
    </div>
  );
};

export default WeatherDataPagination;
